import { Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import MobileNavigation from './MobileNavigation';

import Logo from '../../utils/Logo';
import CustomNavLink from '../../utils/CustomNavLink';

import { ReactComponent as HamburgerNavIcon } from '../../../icons/hamburger-nav.svg';

const MobileNavigationDrawer = ({ userName, ...props }) => {
    return (
        <Drawer placement="top" finalFocusRef={props.btnRef} {...props}>
            <DrawerOverlay />
            <DrawerContent>
                <MobileMenuHeader>
                    <MobileMenuWrapper>
                        <HamburgerNavIcon onClick={props.onClose} />
                    </MobileMenuWrapper>

                    <LogoWrapper>
                        <CustomNavLink to="/" onClick={props.onClose}>
                            <Logo />
                        </CustomNavLink>
                    </LogoWrapper>
                </MobileMenuHeader>

                <MobileMenuContent>
                    <MobileNavigation userName={userName} onClose={props.onClose} />
                </MobileMenuContent>
            </DrawerContent>
        </Drawer>
    );
};

const LogoWrapper = styled.div`
    @media screen and (max-width: 899px) {
        margin: 0 auto;
    }

    a {
        outline: none;
    }
`;

const MobileMenuWrapper = styled.div`
    @media screen and (min-width: 900px) {
        display: none;
    }
`;

const MobileMenuHeader = styled(DrawerHeader)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: var(--chakra-shadows-sm);
    min-height: 80px;
`;

const MobileMenuContent = styled(DrawerBody)`
    padding: 24px;
`;

export default MobileNavigationDrawer;
